<div class="border-stroke-neutral-light shadow-bottom flex justify-between gap-4 rounded-sm border-1 p-4">
  <div class="flex flex-nowrap items-start gap-2">
    <div class="p-xs flex rounded-full" [class]="[bgClass, iconClass]">
      <ng-icon [name]="icone" />
    </div>
    <div class="text-grey-10 flex flex-col gap-1">
      <span class="paragraph-medium-semibold">{{ titre() }}</span>
      <span class="paragraph-medium-medium">{{ message() }}</span>
    </div>
  </div>
  <button (click)="closeToastr()" hlmBtn size="icon" variant="ghost">
    <ng-icon hlm size="base" name="lucideX" />
  </button>
</div>
